export default "__VITE_ASSET__CaVUS0u9__"